import { cn } from "@/lib/utils";
import DOMPurify from "dompurify";

interface RestaurantCardDescriptionProps {
  description: string | null;
  isPro?: boolean;
  vouchers?: string[];
  hasAllergens?: boolean;
}

const ALLERGEN_LEGEND = [
  { num: 1, name: "Glutén" },
  { num: 2, name: "Rák" },
  { num: 3, name: "Tojás" },
  { num: 4, name: "Hal" },
  { num: 5, name: "Földimogyoró" },
  { num: 6, name: "Szója" },
  { num: 7, name: "Tejtermék" },
  { num: 8, name: "Diófélék" },
  { num: 9, name: "Zeller" },
  { num: 10, name: "Mustár" },
  { num: 11, name: "Szezám" },
  { num: 12, name: "Kén-dioxid" },
  { num: 13, name: "Csillagfürt" },
  { num: 14, name: "Puhatestűek" },
];

export function RestaurantCardDescription({
  description,
  isPro = false,
  vouchers,
  hasAllergens = false,
}: RestaurantCardDescriptionProps) {
  // Sanitize HTML to prevent XSS attacks
  const sanitizedDescription = description 
    ? DOMPurify.sanitize(description, {
        ALLOWED_TAGS: ['p', 'br', 'strong', 'em', 'u', 'ul', 'ol', 'li', 'a', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'hr', 'img', 'span', 'div'],
        ALLOWED_ATTR: ['href', 'target', 'rel', 'class', 'style', 'src', 'alt']
      })
    : null;

  const hasContent = sanitizedDescription || (vouchers && vouchers.length > 0) || hasAllergens;

  return (
    <div className="px-4 pt-4 pb-6 text-sm bg-pro-description flex-1 restaurant-card-content min-h-[120px]">
      {sanitizedDescription && (
        <div
          className="prose prose-sm max-w-none"
          dangerouslySetInnerHTML={{ __html: sanitizedDescription }}
        />
      )}
      {vouchers && vouchers.length > 0 && (
        <div className={sanitizedDescription ? "mt-4 pt-3 border-t" : ""}>
          <span style={{ color: '#316498' }}>
            Elfogadott utalványok: {vouchers.join(", ")}
          </span>
        </div>
      )}
      {hasAllergens && (
        <div className={(sanitizedDescription || (vouchers && vouchers.length > 0)) ? "mt-4 pt-3 border-t" : ""}>
          <span className="text-muted-foreground text-xs">
            <strong>Allergének:</strong>{" "}
            {ALLERGEN_LEGEND.map((item, index) => (
              <span key={item.num}>
                <strong>({item.num})</strong> {item.name}
                {index < ALLERGEN_LEGEND.length - 1 && ", "}
              </span>
            ))}
          </span>
        </div>
      )}
    </div>
  );
}
